export default {"src":"/_next/static/media/stamp.b983e15b.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};